import { render, staticRenderFns } from "./InfoServices.vue?vue&type=template&id=73314ac8&"
import script from "./InfoServices.vue?vue&type=script&lang=js&"
export * from "./InfoServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports